SCM = SCM || {};
SCM.SharedWidgets = SCM.SharedWidgets || {};

(function (personalizedContent, $) {

    personalizedContent.init = function () {
        SCM.SharedWidgets.UserPersonalization.AddToLocalStorage('.SCM-SharedWidgets-LocalStorage-UserAffinityTracking', 'data-values');
    };

})(SCM.PersonalizedContent = SCM.PersonalizedContent || {}, jQuery);